// NOTE: it is recommended to use jquery_rpc.js instead, because it's much simpler to use.

/*
 * Base manager class for all page control updating data via rpc.
 */
export default function RpcControlManager() { }

RpcControlManager.timeout = 10000;
RpcControlManager.currentRpcControlManager = undefined;
RpcControlManager.retryController = undefined;

/*
 * General prefix for message names shown by manager.
 */
RpcControlManager.prototype.messagePrefix = "";

/**
 * ID of the request made by <code>makeRemoteCall</code> method or <code>null</code> if no request has been made
 */
RpcControlManager.prototype.requestId = null;

/*
 * Set initial manager state if needed.
 */
RpcControlManager.prototype.init = function()
{
    /* note: inheritor should override this method */
};

/*
 * Call remote service to change control data.
 *
 * @return Request ID
 */
RpcControlManager.prototype.makeRemoteCall = function(callback)
{
    /* note: inheritor should override this method */
};

/*
 * Get remote service used for state changing.
 */
RpcControlManager.prototype.getService = function()
{
    /* note: inheritor should override this method */
};

/**
 * Get list of service methods used by this manager as array of strings
 */
RpcControlManager.prototype.getMethods = function()
{
    /* note: inheritor should override this method */
};

/*
 * Return message text, which will be shown to user when remote call timeout exceeded.
 */
RpcControlManager.prototype.getTimeoutMsg = function()
{
    /* note: inheritor should override this method */
};

/*
 * Handle specific errors.
 * Return true if error was handled, othervise false.
 */
RpcControlManager.prototype.handleSpecificError = function(exception)
{
    /* note: inheritor can override this method for specific error handling*/
    return false;
};

RpcControlManager.prototype.beginSavingData = function()
{
    /* note: inheritor should override this method */
};

RpcControlManager.prototype.endSavingData = function(success)
{
    /* note: inheritor should override this method */
};

/*
 * Event is fired after changing cell state is complete.
 */
RpcControlManager.prototype.onDataSavingComplete = function(result)
{
    /* note: inheritor should override this method */
};

RpcControlManager.prototype.setRequestId = function(id) {
    this.requestId = id;    
};

RpcControlManager.prototype.getRequestId = function() {
    return this.requestId;
};

RpcControlManager.prototype.handleError = function(exception)
{
    if (!this.handleSpecificError(exception))
    {
        alert(this.getRpcErrorMsg());
        this.endSavingData(false);
    }
};

RpcControlManager.prototype.getRpcErrorMsg = function()
{
    /* note: inheritor should override this method */
    return "RPC error";
};

RpcControlManager.prototype.handleNoRightsError = function(exception) {
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsForRemoteCallException') != -1) {
        document.location.reload();
        return true;
    }
    return false;
};



RpcControlManager.saveRpcControlBoundData = function(manager, isSilent)
{
    if (RpcControlManager.isRpcBusy())
    {
        return;
    }

    RpcControlManager.currentRpcControlManager = manager;
    RpcControlManager.currentRpcControlManager.init();
    RpcControlManager.currentRpcControlManager.beginSavingData();

    RpcControlManager.retryController = new RpcRetryController(
            isSilent ? null : RpcControlManager.timeout,
            function() { RpcControlManager.saveRpcControlBoundDataWithDelay() },
            function() { RpcControlManager.timeoutSaving() },
            function( exception ) { RpcControlManager.processRpcError( exception ) }
        );
    RpcControlManager.retryController.start();
};

RpcControlManager.saveRpcControlBoundDataWithDelay = function()
{
    try
    {
        if (!isRpcReady( RpcControlManager.currentRpcControlManager.getMethods() ))
        {
            if (RpcControlManager.isRpcBusy())
            {
                RpcControlManager.retryController.retry();
            }
            return;
        }

        if (RpcControlManager.isRpcBusy() && RpcControlManager.currentRpcControlManager.getService())
        {
            var reqId = RpcControlManager.currentRpcControlManager.makeRemoteCall(RpcControlManager.rpcControlCallback);
            RpcControlManager.currentRpcControlManager.setRequestId(reqId);
        }
        else
        {
            /* service is unavailable, most likely we've been logged out */
            document.location.reload();
        }
    }
    catch(e)
    {
        if (RpcControlManager.isRpcBusy()) RpcControlManager.retryController.handleErrorOrRetry( e );
    }
};

RpcControlManager.rpcControlCallback = function(result, exception)
{
    if( RpcControlManager.isRpcBusy() )
    {
        if( exception != null )
        {
            RpcControlManager.retryController.handleErrorOrRetry( exception );
        }
        else
        {
            RpcControlManager.currentRpcControlManager.endSavingData( true );
            RpcControlManager.currentRpcControlManager.onDataSavingComplete( result );
            RpcControlManager.cleanup();
        }
    }
};

RpcControlManager.cleanup = function()
{
    if (RpcControlManager.isRpcBusy())
    {
        if( RpcControlManager.retryController )
        {
            RpcControlManager.retryController.stop();
            RpcControlManager.retryController = undefined;
        }        
        RpcControlManager.currentRpcControlManager = undefined;
    }
};

RpcControlManager.cancelAllAJAXRequests = function()
{
    // this will release the RpcRetryController and its scheduled timeout.
    RpcControlManager.cleanup();

    // this will release all current and pending AJAX calls
    if( jsonrpc )
        jsonrpc.abortAllRequests();
};

RpcControlManager.processRpcError = function(exception)
{
    if (RpcControlManager.currentRpcControlManager.handleNoRightsError(exception)) {
        return;
    }

    RpcControlManager.currentRpcControlManager.handleError(exception);

    RpcControlManager.cleanup();
};

RpcControlManager.isRpcBusy = function()
{
    return RpcControlManager.currentRpcControlManager != undefined;
};

RpcControlManager.timeoutSaving = function()
{
    if( RpcControlManager.isRpcBusy() )
    {
        var currentRequest = RpcControlManager.currentRpcControlManager.getRequestId( );
        if( currentRequest )
        {
                JSONRpcClient.cancelRequest( currentRequest );
        }
        jsonrpc.abortAllRequests( );

        var msg = RpcControlManager.currentRpcControlManager.getTimeoutMsg( );
        if( !confirm( msg ) )
        {
            RpcControlManager.currentRpcControlManager.endSavingData( false );
            RpcControlManager.cleanup();
        }
        else
        {
            if( RpcControlManager.retryController )
            {
                RpcControlManager.retryController.stop( );
                RpcControlManager.retryController.start( );
            }
        }
    }
};

RpcControlManager.setRpcTimeout = function( newTimeout )
{
    RpcControlManager.timeout = newTimeout;
};


// WEBPACK FOOTER //
// ./web/js/rpc_control_manager.js